<template>
    <v-dialog
        :value="isOpen"
        min-height="400px"
        max-width="600px"
        transition="slide-y-transition"
        eager
        :persistent="actionLoading"
        @keydown.enter="onConfirm"
        @keydown.esc="onAbort"
        @click:outside="onAbort"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    <slot name="title" />
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                <slot name="content" />
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    :color="removal ? 'info' : 'error'"
                    text
                    :disabled="actionLoading"
                    data-sentry-label="Anulowanie"
                    @click="onAbort"
                >
                    <slot name="abortButton">
                        Anuluj
                    </slot>
                </v-btn>

                <v-spacer />

                <v-btn
                    :color="removal ? 'error' : 'success'"
                    text
                    :loading="actionLoading"
                    data-sentry-label="Potwierdzenie"
                    @click="onConfirm"
                >
                    <slot name="confirmButton">
                        Tak
                    </slot>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    name: 'ConfirmDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        data: {
            type: [String, Number, Boolean, Array, Object],
            default: null
        },
        removal: {
            type: Boolean
        },
        actionLoading: {
            type: Boolean
        }
    },
    methods: {
        onConfirm() {
            if (!this.actionLoading) {
                this.$emit('on-confirm', this.data)
            }
        },
        onAbort() {
            if (!this.actionLoading) {
                this.$emit('on-abort')
            }
        }
    }
}
</script>
